import PropTypes from 'prop-types';
import { useCallback } from 'react';

import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/PopUpConfirmDeleteDraft.css';

const RemoveQueuedArtworkConfirmationPopup = ({ open, onClose, onConfirm }) => {
  const t = useTranslations('common.profile.popups.remove_queued_artwork');
  const handleConfirmClick = useCallback(async event => {
    try {
      if (typeof onConfirm === 'function') {
        await onConfirm(event);
      }
    } catch (error) {
      return;
    }

    if (typeof onClose === 'function') {
      onClose();
    }
  }, [onClose, onConfirm]);

  return (
    <GenericPopup open={open} className="popup-confirm-draft-delete-container__popup" opacity>
      <div className="popup-confirm-draft-delete-container relative">
        <div className="popup-confirm-draft-delete-header">
          <Text className="popup-confirm-draft-delete-header-text">
            {t('title')}
          </Text>
          <XIcon className="popup-confirm-draft-delete-close" onClick={onClose} />
        </div>

        <Text className="popup-confirm-draft-delete-text">
          {t('message')}
        </Text>
      </div>
      <div className="popup-confirm-draft-delete_buttons">
        <ContinueButton onClick={handleConfirmClick} className="font-size-medium">
          {t('confirm_button')}
        </ContinueButton>
      </div>
    </GenericPopup>
  );
};

RemoveQueuedArtworkConfirmationPopup.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func
};

RemoveQueuedArtworkConfirmationPopup.defaultProps = {
  open: false,
  onClose: undefined,
  onConfirm: undefined
};

export default RemoveQueuedArtworkConfirmationPopup;
